<template>
  <div class="sovi-faq-page sovi-home">
    <router-link to="/" class="sovi-faq-page__logo">
      <sovi-logo :size="48" />
    </router-link>

    <v-menu offset-y>
      <template #activator="{ props }">
        <v-btn
          class="language-menu"
          size="default"
          color="#eca1c2"
          v-bind="props"
        >
          <template #prepend>
            <v-icon icon="mdi-web" />
          </template>

          {{ $i18n.locale.toUpperCase() }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="option in $i18n.availableLocales"
          :key="option"
          class="align-items-center"
          @click="onLocaleChange(option)"
        >
          <v-row align="center" no-gutters>
            {{ option.toUpperCase() }}
          </v-row>
        </v-list-item>
      </v-list>
    </v-menu>

    <sovi-content-nav />

    <sovi-home-card
      background="/images/desk.webp"
      src="/images/ukk-1.webp"
      :title="t('pageTitle')"
      fixed
      style="padding-top: 100px"
    >
      <strong>{{ t('pageIntro') }}</strong>

      <p>
        {{ t('pageDescription') }}
      </p>

      <template #button>
        <router-link
          to="/sahkoinen-allekirjoitus"
          class="font-weight-bold text-decoration-underline text-black"
        >
          ← {{ t('backToMain') }}
        </router-link>
      </template>
    </sovi-home-card>

    <div class="sovi-faq-page__panels">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq1Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq1Answer1') }}</p>

            <p>{{ t('faq1Answer2') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq2Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq2Answer1') }}</p>

            <p>{{ t('faq2Answer2') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq3Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq3Answer1') }}</p>

            <p>{{ t('faq3Answer2') }}</p>

            <ul>
              <li>{{ t('faq3List1') }}</li>

              <li>{{ t('faq3List2') }}</li>

              <li>{{ t('faq3List3') }}</li>

              <li>{{ t('faq3List4') }}</li>

              <li>{{ t('faq3List5') }}</li>

              <li>{{ t('faq3List6') }}</li>

              <li>{{ t('faq3List7') }}</li>

              <li>{{ t('faq3List8') }}</li>

              <li>{{ t('faq3List9') }}</li>

              <li>{{ t('faq3List10') }}</li>

              <li>{{ t('faq3List11') }}</li>

              <li>{{ t('faq3List12') }}</li>
            </ul>

            <p>{{ t('faq3Answer3') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq4Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq4Answer1') }}</p>

            <p>{{ t('faq4Answer2') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq5Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq5Answer1') }}</p>

            <p>{{ t('faq5Answer2') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq6Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq6Answer1') }}</p>

            <p>{{ t('faq6Answer2') }}</p>

            <ul>
              <li>{{ t('faq6List1') }}</li>

              <li>{{ t('faq6List2') }}</li>

              <li>{{ t('faq6List3') }}</li>

              <li>{{ t('faq6List4') }}</li>
            </ul>

            <p>{{ t('faq6Answer3') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq7Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq7Answer1') }}</p>

            <p>{{ t('faq7Answer2') }}</p>

            <ul>
              <li>{{ t('faq7List1') }}</li>

              <li>{{ t('faq7List2') }}</li>

              <li>{{ t('faq7List3') }}</li>

              <li>{{ t('faq7List4') }}</li>

              <li>{{ t('faq7List5') }}</li>

              <li>{{ t('faq7List6') }}</li>

              <li>{{ t('faq7List7') }}</li>

              <li>{{ t('faq7List8') }}</li>
            </ul>

            <p>{{ t('faq7Answer3') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq8Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq8Answer1') }}</p>

            <p>{{ t('faq8Answer2') }}</p>

            <ul>
              <li>{{ t('faq8List1') }}</li>

              <li>{{ t('faq8List2') }}</li>

              <li>{{ t('faq8List3') }}</li>

              <li>{{ t('faq8List4') }}</li>

              <li>{{ t('faq8List5') }}</li>
            </ul>

            <p>{{ t('faq8Answer3') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq9Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq9Answer1') }}</p>

            <p>{{ t('faq9Answer2') }}</p>

            <ul>
              <li>{{ t('faq9List1') }}</li>

              <li>{{ t('faq9List2') }}</li>

              <li>{{ t('faq9List3') }}</li>

              <li>{{ t('faq9List4') }}</li>
            </ul>

            <p>{{ t('faq9Answer3') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-title>
            {{ t('faq10Question') }}
          </v-expansion-panel-title>

          <v-expansion-panel-text>
            <p>{{ t('faq10Answer1') }}</p>

            <p>{{ t('faq10Answer2') }}</p>

            <ul>
              <li>{{ t('faq10List1') }}</li>

              <li>{{ t('faq10List2') }}</li>

              <li>{{ t('faq10List3') }}</li>

              <li>{{ t('faq10List4') }}</li>

              <li>{{ t('faq10List5') }}</li>
            </ul>

            <p>{{ t('faq10Answer3') }}</p>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="sovi-faq-page__links">
      <h3 class="home-title font-bold">{{ t('relatedPages') }}</h3>

      <div style="display: grid; gap: 8px; margin-top: 16px">
        <router-link
          to="/sahkoinen-allekirjoitus"
          class="font-weight-medium text-decoration-underline text-black"
        >
          {{ t('linkEsignature') }} →
        </router-link>

        <router-link
          to="/tyosopimuksen-sahkoinen-allekirjoitus"
          class="font-weight-medium text-decoration-underline text-black"
        >
          {{ t('linkEmployment') }} →
        </router-link>

        <router-link
          to="/vuokrasopimuksen-sahkoinen-allekirjoitus"
          class="font-weight-medium text-decoration-underline text-black"
        >
          {{ t('linkRental') }} →
        </router-link>
      </div>
    </div>

    <div class="sovi-faq-page__login">
      <sovi-home-login />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useTheme } from 'vuetify';
import { definePage } from 'vue-router/auto';
import { useRouteMeta } from '@/composables/useRouteMeta';
import { useAuthorizationStore } from '@/stores/authorization';
import { loadRecaptcha } from '@/plugins/recaptcha';
import SoviHomeLogin from '@/components/home/SoviHomeLogin.vue';

definePage({
  meta: {
    hero: false,
    restricted: false,
    maxContainer: true,
  },
});

useRouteMeta({
  title: 'Usein kysytyt kysymykset sähköisestä allekirjoituksesta | Sovi.fi',
  description:
    'Vastaukset 10 yleisimpään kysymykseen sähköisestä allekirjoituksesta. Onko sähköinen allekirjoitus sitova? Mitä asiakirjoja voi allekirjoittaa? Lue lisää.',
});

const { locale } = useI18n({ useScope: 'global' });

const { t } = useI18n();

const theme = useTheme();

const { isAuthorized } = useAuthorizationStore();

const onLocaleChange = (newLocale: string) => {
  locale.value = newLocale;
  localStorage.setItem('sovi-locale', newLocale);
};

onMounted(() => {
  document.getElementById('sovi-main')?.scrollTo(0, 0);
  window.scrollTo(0, 0);
  loadRecaptcha();

  const storedLocale = localStorage.getItem('sovi-locale');

  if (storedLocale && storedLocale !== locale.value) {
    locale.value = storedLocale;
  }

  theme.global.name.value = 'light';

  isAuthorized();
});
</script>

<style lang="scss">
.grecaptcha-badge {
  visibility: hidden;
}

.sovi-faq-page {
  position: relative;
  background-color: #fff;
  font-size: clamp(18px, 2vw, 22px);

  &__logo {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 2;
  }

  .language-menu {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 2;
    box-shadow:
      rgba(0, 0, 0, 0.15) 0px 15px 25px,
      rgba(0, 0, 0, 0.05) 0px 5px 10px;
  }

  .home-title {
    line-height: 1.3;

    @media (min-width: 768px) {
      line-height: 1.1;
    }
    --title-color: rgb(var(--v-theme-primary));

    &.alt {
      --title-color: #eca1c2;
    }

    &::first-letter {
      padding-bottom: 2px;
      box-shadow: inset 0 calc(-1 * clamp(4px, 0.5vw, 6px)) 0 0
        var(--title-color);
    }
  }

  &__panels {
    padding: clamp(32px, 5vw, 64px) clamp(16px, 5vw, 32px);
    max-width: 960px;
    margin: 0 auto;

    .v-expansion-panel-title {
      font-size: clamp(16px, 2vw, 20px);
      font-weight: 600;
    }

    .v-expansion-panel-text {
      font-size: clamp(14px, 1.5vw, 18px);

      p {
        margin-bottom: 12px;
      }

      ul {
        margin-bottom: 12px;
        padding-left: 24px;

        li {
          margin-bottom: 4px;
        }
      }
    }
  }

  &__links {
    padding: 0 clamp(16px, 5vw, 32px) clamp(32px, 5vw, 64px);
    max-width: 960px;
    margin: 0 auto;
  }

  &__login {
    overflow: hidden;

    .sovi-home__login {
      &::before,
      &::after {
        display: none;
      }
    }
    background-color: #fff;
    padding: clamp(32px, 5vw, 64px) clamp(16px, 5vw, 32px);

    .sovi-home__login-form {
      display: grid;
      gap: clamp(16px, 3vw, 32px);
      position: relative;
      z-index: 1;

      h1 {
        font-size: clamp(24px, 3vw, 32px);
      }
    }
  }
}
</style>

<i18n lang="json">
{
  "fi": {
    "pageTitle": "Usein kysytyt kysymykset",
    "pageIntro": "10 yleisintä kysymystä sähköisestä allekirjoituksesta",
    "pageDescription": "Tämän osion avulla löydät vastaukset yleisimpiin kysymyksiin sähköiseen allekirjoitukseen liittyen.",
    "backToMain": "Takaisin sähköinen allekirjoitus -sivulle",
    "relatedPages": "Lue lisää",
    "linkEsignature": "Sähköinen allekirjoitus",
    "linkEmployment": "Työsopimuksen sähköinen allekirjoitus",
    "linkRental": "Vuokrasopimuksen sähköinen allekirjoitus",
    "faq1Question": "1. Mitä sähköinen allekirjoitus tarkoittaa?",
    "faq1Answer1": "Sähköinen allekirjoitus on digitaalinen tapa hyväksyä ja allekirjoittaa asiakirja ilman paperia. Sen avulla sopimukset, valtakirjat, pöytäkirjat ja muut asiakirjat voidaan allekirjoittaa verkossa nopeasti ja turvallisesti.",
    "faq1Answer2": "Sähköinen allekirjoitus nopeuttaa sopimusprosessia, vähentää paperityötä ja mahdollistaa asiakirjojen allekirjoittamisen ajasta ja paikasta riippumatta. Yrityksille se tarkoittaa tehokkaampia toimintatapoja, parempaa asiakaskokemusta ja vähemmän hallinnollista työtä.",
    "faq2Question": "2. Onko sähköinen allekirjoitus juridisesti sitova Suomessa?",
    "faq2Answer1": "Kyllä. Sähköinen allekirjoitus on useimmissa tilanteissa oikeudellisesti sitova, kun se on toteutettu asianmukaisesti. Euroopan unionin eIDAS-asetus määrittelee sähköisten allekirjoitusten oikeudellisen aseman ja luo yhtenäiset pelisäännöt koko EU:n alueelle.",
    "faq2Answer2": "Joissakin asiakirjoissa voi kuitenkin olla lainsäädännöstä johtuvia erityisvaatimuksia. Siksi erityistilanteet kannattaa arvioida tapauskohtaisesti.",
    "faq3Question": "3. Mitä asiakirjoja voidaan allekirjoittaa sähköisesti?",
    "faq3Answer1": "Sähköinen allekirjoitus soveltuu hyvin useimpiin yritysten ja organisaatioiden käyttämiin asiakirjoihin.",
    "faq3Answer2": "Tyypillisiä esimerkkejä ovat:",
    "faq3List1": "työsopimukset",
    "faq3List2": "vuokrasopimukset",
    "faq3List3": "toimeksiantosopimukset",
    "faq3List4": "palvelusopimukset",
    "faq3List5": "tarjousasiakirjat",
    "faq3List6": "salassapitosopimukset eli NDA-sopimukset",
    "faq3List7": "konsulttisopimukset",
    "faq3List8": "hankintasopimukset",
    "faq3List9": "hallituksen pöytäkirjat",
    "faq3List10": "valtakirjat",
    "faq3List11": "yhteistyösopimukset",
    "faq3List12": "asiakassopimukset",
    "faq3Answer3": "Sähköinen allekirjoitus soveltuu yhtä hyvin yksittäisiin sopimuksiin kuin suuriin asiakirjamääriin.",
    "faq4Question": "4. Voiko asiakirjan allekirjoittaa puhelimella?",
    "faq4Answer1": "Kyllä. Nykyaikaiset sähköiset allekirjoituspalvelut toimivat myös mobiililaitteilla.",
    "faq4Answer2": "Allekirjoittaja voi avata allekirjoituspyynnön sähköpostista ja allekirjoittaa asiakirjan helposti älypuhelimella tai tabletilla. Tämä tekee prosessista sujuvan erityisesti silloin, kun allekirjoittajat työskentelevät etänä tai matkustavat.",
    "faq5Question": "5. Kuinka kauan sähköinen allekirjoitus kestää?",
    "faq5Answer1": "Useimmissa tapauksissa itse allekirjoittamiseen kuluu vain muutama minuutti.",
    "faq5Answer2": "Kun asiakirja on lähetetty, vastaanottaja voi allekirjoittaa sen heti. Yrityksen näkökulmasta koko sopimusprosessi voi lyhentyä päivistä tai viikoista jopa saman päivän aikana valmiiksi.",
    "faq6Question": "6. Miten sähköinen allekirjoitus parantaa tietoturvaa?",
    "faq6Answer1": "Sähköinen allekirjoitus tarjoaa paremman jäljitettävyyden kuin pelkkä paperinen allekirjoitus.",
    "faq6Answer2": "Hyvin toteutetussa allekirjoitusprosessissa voidaan tallentaa esimerkiksi:",
    "faq6List1": "allekirjoituksen ajankohta",
    "faq6List2": "allekirjoitusprosessin vaiheet",
    "faq6List3": "asiakirjan tila",
    "faq6List4": "tapahtumaloki",
    "faq6Answer3": "Lisäksi asiakirjat voidaan säilyttää keskitetysti, jolloin niiden hallinta ja käyttöoikeuksien valvonta helpottuvat.",
    "faq7Question": "7. Mitä hyötyä sähköisestä allekirjoituksesta on yritykselle?",
    "faq7Answer1": "Yritykset ottavat sähköisen allekirjoituksen käyttöön ennen kaikkea tehokkuuden vuoksi.",
    "faq7Answer2": "Keskeisiä hyötyjä ovat:",
    "faq7List1": "nopeammat sopimusprosessit",
    "faq7List2": "vähemmän paperityötä",
    "faq7List3": "pienemmät postitus- ja tulostuskustannukset",
    "faq7List4": "parempi asiakirjojen hallinta",
    "faq7List5": "sujuvampi asiakaskokemus",
    "faq7List6": "helpompi etäasiointi",
    "faq7List7": "nopeampi rekrytointi",
    "faq7List8": "ajansäästö henkilöstölle",
    "faq7Answer3": "Kun hallinnollinen työ vähenee, työntekijöiden aikaa vapautuu liiketoiminnan kannalta tärkeämpiin tehtäviin.",
    "faq8Question": "8. Voiko useampi henkilö allekirjoittaa saman asiakirjan?",
    "faq8Answer1": "Kyllä. Monissa tilanteissa sama asiakirja tarvitsee useamman allekirjoituksen.",
    "faq8Answer2": "Esimerkiksi:",
    "faq8List1": "työnantaja ja työntekijä",
    "faq8List2": "vuokranantaja ja vuokralainen",
    "faq8List3": "ostaja ja myyjä",
    "faq8List4": "kaksi yhteistyökumppania",
    "faq8List5": "hallituksen jäsenet",
    "faq8Answer3": "Sähköisessä allekirjoitusprosessissa voidaan määrittää allekirjoittajat ja tarvittaessa myös allekirjoitusjärjestys, mikä tekee prosessista selkeän ja helposti seurattavan.",
    "faq9Question": "9. Kuinka sähköinen allekirjoitus auttaa etätyössä?",
    "faq9Answer1": "Etätyö on muuttanut yritysten toimintatapoja pysyvästi. Sähköinen allekirjoitus mahdollistaa sopimusten hyväksymisen ilman toimistokäyntiä tai paperisia asiakirjoja.",
    "faq9Answer2": "Tämä on hyödyllistä esimerkiksi silloin, kun:",
    "faq9List1": "uusi työntekijä aloittaa etänä",
    "faq9List2": "asiakas sijaitsee toisella paikkakunnalla",
    "faq9List3": "yhteistyökumppanit toimivat eri maissa",
    "faq9List4": "päätöksiä halutaan tehdä nopeasti",
    "faq9Answer3": "Sähköinen allekirjoitus poistaa maantieteelliset esteet sopimusten tekemiseltä ja tekee yhteistyöstä joustavampaa.",
    "faq10Question": "10. Miksi valita Sovi.fi sähköiseen allekirjoittamiseen?",
    "faq10Answer1": "Sovi.fi on kotimainen sähköisen allekirjoituksen ja asiakirjahallinnan palvelu, joka on suunniteltu helpottamaan yritysten arkea.",
    "faq10Answer2": "Palvelun avulla voit:",
    "faq10List1": "lähettää asiakirjoja allekirjoitettavaksi nopeasti",
    "faq10List2": "seurata allekirjoitusprosessia reaaliajassa",
    "faq10List3": "hyödyntää valmiita asiakirjamalleja",
    "faq10List4": "säilyttää asiakirjat turvallisesti yhdessä paikassa",
    "faq10List5": "hallita sopimuksia tehokkaasti koko niiden elinkaaren ajan",
    "faq10Answer3": "Joustavan hinnoittelun ansiosta palvelu soveltuu sekä pienille yrityksille että suuremmille organisaatioille. Yritys voi ottaa sähköisen allekirjoituksen käyttöön ilman raskasta käyttöönottoa ja hyödyntää palvelua juuri omien tarpeidensa mukaisesti."
  },
  "en": {
    "pageTitle": "Frequently Asked Questions",
    "pageIntro": "10 most common questions about electronic signatures",
    "pageDescription": "In this section, you'll find answers to the most common questions about electronic signatures.",
    "backToMain": "Back to electronic signature page",
    "relatedPages": "Read more",
    "linkEsignature": "Electronic signature",
    "linkEmployment": "Electronic signing of employment contracts",
    "linkRental": "Electronic signing of rental agreements",
    "faq1Question": "1. What is an electronic signature?",
    "faq1Answer1": "An electronic signature is a digital way to approve and sign a document without paper. It allows contracts, powers of attorney, minutes, and other documents to be signed online quickly and securely.",
    "faq1Answer2": "Electronic signatures speed up the contract process, reduce paperwork, and enable documents to be signed regardless of time and place. For businesses, this means more efficient workflows, better customer experience, and less administrative work.",
    "faq2Question": "2. Is an electronic signature legally binding in Finland?",
    "faq2Answer1": "Yes. An electronic signature is legally binding in most situations when it has been properly implemented. The European Union's eIDAS regulation defines the legal status of electronic signatures and establishes common rules across the entire EU.",
    "faq2Answer2": "However, some documents may have specific legal requirements. Therefore, special cases should be assessed on a case-by-case basis.",
    "faq3Question": "3. What documents can be signed electronically?",
    "faq3Answer1": "Electronic signatures are well suited for most documents used by companies and organizations.",
    "faq3Answer2": "Typical examples include:",
    "faq3List1": "employment contracts",
    "faq3List2": "rental agreements",
    "faq3List3": "assignment agreements",
    "faq3List4": "service agreements",
    "faq3List5": "proposals and quotations",
    "faq3List6": "non-disclosure agreements (NDAs)",
    "faq3List7": "consulting agreements",
    "faq3List8": "procurement contracts",
    "faq3List9": "board meeting minutes",
    "faq3List10": "powers of attorney",
    "faq3List11": "partnership agreements",
    "faq3List12": "client agreements",
    "faq3Answer3": "Electronic signatures work equally well for individual contracts and large volumes of documents.",
    "faq4Question": "4. Can a document be signed on a mobile phone?",
    "faq4Answer1": "Yes. Modern electronic signature services also work on mobile devices.",
    "faq4Answer2": "The signer can open the signature request from email and easily sign the document on a smartphone or tablet. This makes the process seamless, especially when signers are working remotely or traveling.",
    "faq5Question": "5. How long does an electronic signature take?",
    "faq5Answer1": "In most cases, the actual signing takes only a few minutes.",
    "faq5Answer2": "Once the document has been sent, the recipient can sign it immediately. From a business perspective, the entire contract process can be shortened from days or weeks to being completed within the same day.",
    "faq6Question": "6. How does an electronic signature improve security?",
    "faq6Answer1": "An electronic signature offers better traceability than a paper signature alone.",
    "faq6Answer2": "A well-implemented signing process can record, for example:",
    "faq6List1": "the time of signing",
    "faq6List2": "the steps of the signing process",
    "faq6List3": "the document status",
    "faq6List4": "an event log",
    "faq6Answer3": "In addition, documents can be stored centrally, making their management and access control easier.",
    "faq7Question": "7. What are the benefits of electronic signatures for businesses?",
    "faq7Answer1": "Businesses adopt electronic signatures primarily for efficiency.",
    "faq7Answer2": "Key benefits include:",
    "faq7List1": "faster contract processes",
    "faq7List2": "less paperwork",
    "faq7List3": "lower mailing and printing costs",
    "faq7List4": "better document management",
    "faq7List5": "smoother customer experience",
    "faq7List6": "easier remote transactions",
    "faq7List7": "faster recruitment",
    "faq7List8": "time savings for staff",
    "faq7Answer3": "When administrative work is reduced, employees' time is freed up for tasks that are more important to the business.",
    "faq8Question": "8. Can multiple people sign the same document?",
    "faq8Answer1": "Yes. In many situations, the same document requires multiple signatures.",
    "faq8Answer2": "For example:",
    "faq8List1": "employer and employee",
    "faq8List2": "landlord and tenant",
    "faq8List3": "buyer and seller",
    "faq8List4": "two partners",
    "faq8List5": "board members",
    "faq8Answer3": "In an electronic signing process, you can define the signers and, if needed, the signing order, making the process clear and easy to follow.",
    "faq9Question": "9. How does an electronic signature help with remote work?",
    "faq9Answer1": "Remote work has permanently changed how businesses operate. Electronic signatures enable contracts to be approved without office visits or paper documents.",
    "faq9Answer2": "This is useful, for example, when:",
    "faq9List1": "a new employee starts remotely",
    "faq9List2": "a client is in a different city",
    "faq9List3": "partners operate in different countries",
    "faq9List4": "decisions need to be made quickly",
    "faq9Answer3": "Electronic signatures remove geographical barriers from contract-making and make collaboration more flexible.",
    "faq10Question": "10. Why choose Sovi.fi for electronic signing?",
    "faq10Answer1": "Sovi.fi is a Finnish electronic signature and document management service designed to make everyday business easier.",
    "faq10Answer2": "With the service, you can:",
    "faq10List1": "send documents for signing quickly",
    "faq10List2": "track the signing process in real time",
    "faq10List3": "use ready-made document templates",
    "faq10List4": "store documents securely in one place",
    "faq10List5": "manage contracts efficiently throughout their lifecycle",
    "faq10Answer3": "Thanks to flexible pricing, the service suits both small businesses and larger organizations. A company can start using electronic signatures without a complex setup and use the service according to their specific needs."
  }
}
</i18n>
